import { useAuthStore } from "@/stores/auth/authStore";
import { storeToRefs } from "pinia";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			component: () => import("@/layouts/DefaultLayout.vue"),
			meta: { requiresAuth: true },
			children: [
				{
					path: "",
					redirect: "map",
					meta: { showNavbarTabs: true },
				},
				{
					path: "map",
					name: "map",
					component: () => import("@/views/map/MapView.vue"),
					meta: { showNavbarTabs: true },
				},
				{
					path: "settings/mfa",
					name: "MfaSettings",
					component: () => import("@/views/auth/MfaSetupPage.vue"),
					meta: { showNavbarTabs: false },
				},
			],
		},
		{
			path: "/login",
			component: () => import("@/layouts/AuthLayout.vue"),
			meta: { requiresAuth: false },
			children: [
				{
					path: "",
					name: "login",
					component: () => import("@/views/auth/LoginView.vue"),
				},
				{
					path: "/verify2fa",
					name: "verify2fa",
					component: () => import("@/views/auth/VerifyMfaView.vue"),
				},
			],
		},
		{
			path: "/:pathMatch(.*)*", // 404 catch-all
			name: "not-found",
			component: () => import("@/views/errors/NotFoundView.vue"),
		},
	],
});

router.beforeEach(async (to) => {
	const { is2faPending, isAuthenticated } = storeToRefs(useAuthStore());
	const requiresAuth = to.meta.requiresAuth === true;
	const isAuthRoute = to.name === "login" || to.name === "verify2fa";

	// Fully authenticated users shouldn't see login/verify2fa
	if (isAuthenticated.value && isAuthRoute) {
		return { name: "map" };
	}

	if (!requiresAuth) {
		return;
	}

	if (is2faPending.value) {
		if (to.name === "login") {
			is2faPending.value = false;
			isAuthenticated.value = false;
			return;
		}
		return { name: "verify2fa", query: { redirect: to.fullPath } };
	}

	if (!isAuthenticated.value) {
		return { name: "login" };
	}
	// requiresAuth && isAuthenticated && !is2faPending → fall through, allow
});

export default router;
